module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/app-img-28590384f1aa82d86d6c729573dd219a.png";